<template>
  <div class="plan-messages">
    <div v-if="$store.getters['subscriptions/active'].canceled" class="subtext">
      <IconWarning />
      <span>{{ texts.canceled }}</span>
    </div>
    <div v-if="$route.query.alert && texts[$route.query.alert]" class="subtext alert-inline">
      <IconWarning />
      <span v-html="texts[$route.query.alert]" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IconWarning from '../assets/svg/icon-exam-warning.svg?vue-component';

export default {
  components: { IconWarning },
  props: {
    version: { type: String, default: '1' },
  },
  computed: {
    ...mapGetters({ subscription: 'subscriptions/active' }),
    planTitle() {
      if (this.$route.query.currentPlan && (this.$route.query.alert === 'extend-no-better-price' || this.$route.query.alert === 'already-purchased')) {
        return this.$route.query.currentPlan.charAt(0).toUpperCase() + this.$route.query.currentPlan.slice(1);
      }
      if (this.subscription.provider === 'teachable') {
        return 'Teachable';
      }
      if (this.subscription.plan.free) {
        return 'Free';
      }
      if (this.subscription.plan.id === 3) {
        return 'Lifetime';
      }
      return `Premium ${this.subscription.plan.title.split(' ')[0]}`;
    },
    nextChargeFormatted() {
      if (this.subscription.nextCharge) {
        return new Date(this.subscription.nextCharge).toString().split(' ')
          .slice(1, 4)
          .join(' ');
      }

      return '';
    },
    texts() {
      if (this.version === '2') {
        return {
          canceled: `Your ${this.planTitle} Plan is now canceled. But you still have full access to the ${this.$config.platformName} Program until ${this.nextChargeFormatted}. Afterward, your account will be downgraded to a Free Plan with the possibility to resubscribe to one of our Premium Plans.`,
          'existing-lifetime': 'You have an active Lifetime Plan.',
          downgrade: 'You have an active subscription. To downgrade, cancel your current plan, wait for it to expire, then resubscribe to the desired plan.',
          'extend-no-better-price': `You are already subscribed to the ${this.planTitle} Plan.`,
          'already-purchased': `You are already subscribed to the ${this.planTitle} Plan.`,
          'course-purchased': 'You have already purchased this course.',
          'fs-not-allowed': 'To upgrade your plan, please select your desired option below.',
          lifetime: 'Please contact support if you want to purchase a Lifetime Plan.',
          'invalid-email': 'The invitation email and registration email don\'t match.',
        };
      }

      return {
        canceled: `Your subscription to the ${this.planTitle} plan has been canceled. You still have full access to the ${this.$config.platformName} Program until ${this.nextChargeFormatted}. After that, your account will be downgraded to Free Plan and you will be able to resubscribe to one of our Premium plans.`,
        'existing-lifetime': 'You have an active Lifetime access.',
        downgrade: 'You have an active subscription. To downgrade, you need to cancel your current plan and resubscribe once your Premium access has expired.',
        'extend-no-better-price': `You are already subscribed to the ${this.planTitle} plan`,
        'already-purchased': `You are already subscribed to the ${this.planTitle} plan`,
        'course-purchased': 'You have already purchased this course',
        'fs-not-allowed': 'If you wish to upgrade your plan, please select the plan you wish to purchase below',
        lifetime: 'Please contact support if you wish to purchase the lifetime plan',
        'invalid-email': 'The invitation email and registration email don\'t match',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.subtext {
  background: var(--main-dark-shade-3);
  border: 1px solid var(--main-dark-shade-2);
  box-sizing: border-box;
  border-radius: 5px;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: var(--main-light);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: var(--spacing-16) var(--spacing-32);
  margin: 0 auto;
  width: 100%;
  max-width: 90%;
  margin-top: 54px;

  &.alert-inline {
    display: flex;
    align-items: center;
  }

  span {
    width: 100%;
    margin-left: var(--spacing-12);
  }

  & + .subtext {
    margin-top: var(--spacing-8);
  }

  @include bp($bp-laptop) {
    max-width: 87%;
  }

  @include bp($bp-mobile) {
    max-width: 100%;
  }
}
</style>
